var _path, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStsSolar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "solar_power"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solar_power_2",
    d: "M3.32044 3.37812V1.93066H6.21536V3.37812H3.32044ZM2.35547 21.2301H11.2815V17.129H3.1757L2.35547 21.2301ZM6.07061 8.68547L5.03327 7.67225L7.08384 5.62168L8.12118 6.63491L6.07061 8.68547ZM3.46519 15.6815H11.2815V11.5804H4.28541L3.46519 15.6815ZM12.0052 6.27304C10.8151 6.27304 9.80988 5.85087 8.98966 5.00651C8.16943 4.16216 7.72715 3.13688 7.66282 1.93066H16.3476C16.2832 3.13688 15.841 4.16216 15.0207 5.00651C14.2005 5.85087 13.1953 6.27304 12.0052 6.27304ZM11.2815 10.6154V7.7205H12.7289V10.6154H11.2815ZM12.7289 21.2301H21.6549L20.8347 17.129H12.7289V21.2301ZM12.7289 15.6815H20.5452L19.725 11.5804H12.7289V15.6815ZM17.9398 8.66135L15.8892 6.61078L16.9024 5.59756L18.9771 7.624L17.9398 8.66135ZM17.795 3.37812V1.93066H20.6899V3.37812H17.795Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_206_2767",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.429688,
    width: 23.1593,
    height: 23.1593,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_206_2767)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStsSolar);
export default __webpack_public_path__ + "static/media/sts_solar.459bbf9ffe385aab75521437f1a18ccd.svg";
export { ForwardRef as ReactComponent };